import React from 'react';
import { useTranslation } from 'react-i18next';
import classes from './FailConnection.module.scss';

import { getEnv } from '@config';

const { publicPath } = getEnv();

const FailConnection = () => {
  const { t } = useTranslation();

  return (
    <div id="failConnection-container" className={classes.failContainer}>
      <img src={`${publicPath}/no-connection.svg`} alt="imagen de error de conexion" id="img-connect-error" />
      <h5 id="subtitle-fail-connection">
        {t('Onboarding.MerchantOnboarding.documentationForm.uploadErrorTitle')}
      </h5>
      <p id="p-fail-connection">
        {t('Onboarding.MerchantOnboarding.documentationForm.uploadErrorSubtitle')}
      </p>
    </div>
  );
};
export default FailConnection;
